import React from 'react'

const Disclaimer = () => {
    return (
        <div className="disclaimer">
            <h3>Attention!</h3>
            <p>Recently it came to my attention that 
                someone posted an obscene photo here.  
                This is a professional portfolio application meant 
                to be presented to recruiters - this is not okay!  </p>
            <p>Who so ever is doing this needs to cease and desist or legal action will be taken</p>
        </div>
    )
}

export default Disclaimer;